import { render, staticRenderFns } from "./KanbanGirlCustomerService.vue?vue&type=template&id=6e79f9f6&scoped=true"
import script from "./KanbanGirlCustomerService.vue?vue&type=script&lang=js"
export * from "./KanbanGirlCustomerService.vue?vue&type=script&lang=js"
import style0 from "./KanbanGirlCustomerService.vue?vue&type=style&index=0&id=6e79f9f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e79f9f6",
  null
  
)

export default component.exports